/**
 * @description Learnosity looks for DOM Hook to attach its code,
 * if hook is not present (due to component being unmounted), warning alert is shown.
 * To avoid this, suppress alerts for limited amount of time.
 */
const suppressLearnosityAlerts = () => {
  const alertReference = window.alert;
  window.alert = () => {};
  setTimeout(() => {
    window.alert = alertReference;
  }, 3000);
};

export default suppressLearnosityAlerts;
